import { render, staticRenderFns } from "./DeleteOrderButton.vue?vue&type=template&id=60d4d4be&scoped=true&"
import script from "./DeleteOrderButton.vue?vue&type=script&lang=js&"
export * from "./DeleteOrderButton.vue?vue&type=script&lang=js&"
import style0 from "./DeleteOrderButton.vue?vue&type=style&index=0&id=60d4d4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4d4be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60d4d4be')) {
      api.createRecord('60d4d4be', component.options)
    } else {
      api.reload('60d4d4be', component.options)
    }
    module.hot.accept("./DeleteOrderButton.vue?vue&type=template&id=60d4d4be&scoped=true&", function () {
      api.rerender('60d4d4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/Buttons/DeleteOrderButton.vue"
export default component.exports